export const bulkUtmMessages = {
  bulkUtm: 'Bulk UTM',
  bulkUtmTitle: 'Bulk UTM parameters',
  bulkUtmScope: 'Scope',
  bulkUtmSelectedScope: 'Selected links ({count})',
  bulkUtmFilteredScope: 'Current filters ({count} links)',
  bulkUtmMode: 'Mode',
  bulkUtmAddMissing: 'Add missing parameters',
  bulkUtmReplaceSelected: 'Replace selected parameters',
  bulkUtmRemoveSelected: 'Remove selected parameters',
  bulkUtmGuidance: 'Preview is required. Unrelated query parameters, fragments, and raw encoding are preserved. Credentialed URLs are skipped.',
  bulkUtmSelectParameter: 'Select at least one UTM parameter.',
  bulkUtmValueRequired: 'Enter a value for every selected parameter.',
  bulkUtmPreviewSummary: '{total} matched · {ready} ready · {unchanged} unchanged · {invalid} invalid',
  bulkUtmConflicts: '{count} URL(s) contain duplicate selected parameters that will be normalized.',
  bulkUtmConflictRow: 'Duplicate: {parameters}',
  bulkUtmLimitExceeded: '{total} links match, exceeding the safe limit of {limit}. Narrow the filters and preview again.',
  bulkUtmBackupHint: 'The downloaded CSV records old and new URLs. Keep a current backup before large production changes.',
  bulkUtmBefore: 'Before',
  bulkUtmAfter: 'After',
  bulkUtmApply: 'Apply UTM changes',
  bulkUtmComplete: 'Updated {changed} links; skipped {skipped}.',
} as const;
